/**
 * Build a Multi Badger URL for a list of login names.
 * Multi Badger shows org hierarchy for multiple employees side-by-side.
 */
export const generateMultiBadgerUrl = (loginNames: string[]): string => {
  const logins = loginNames
    .filter(Boolean)
    .map((alias) => `${alias}@`)
    .join(',');
  return `https://multi.badger.amazon.dev/index.html?logins=${logins}`;
};
